module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/steps-phone@2x-6acf3ddc3c3e1274f6de68e4cb759c09.png";